import { PaneArea } from '../../../../types/shared'
import Pitchfork, { IPitchforkAttrs } from '../../../canvas/pitchfork/pitchfork_v1'
import PaneModel from '../../../models/pane'

type Area = PaneArea
type Attrs = IPitchforkAttrs
type PartialAttrs = Partial<Attrs>

const SIZE_IN_PIXELS = 35

class PitchforkCreator extends Pitchfork<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    const width = this.model.scale.x.width(SIZE_IN_PIXELS)
    const height = this.model.scale.y.height(SIZE_IN_PIXELS)
    this.attrs.x1 = startArea.x - width
    this.attrs.x2 = startArea.x + width
    this.attrs.x3 = startArea.x
    this.attrs.y1 = startArea.y + height / 2
    this.attrs.y2 = startArea.y + height / 2
    this.attrs.y3 = startArea.y - height / 2

    setTimeout(() => {
      this.replaceMyself(Pitchfork.fromObject<Pitchfork>(this.attrs, this.model))
      toolsCallback()
    })

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }
}

export default PitchforkCreator
